import { createMuiTheme } from '@material-ui/core/styles';
import { kassimBlue } from './theme';

const muiTheme = createMuiTheme({
    palette: {
        primary: {
            main: kassimBlue,
        },
        // secondary: {
        //     main: kassimGreen,
        // },
    },
});

export default muiTheme;
